import { optionalKey } from "@grandvisionhq/utils";
import { unwrapResponse } from "../../response.js";
import { authHeader, postJson, acceptJson } from "../../shared.js";
async function changeAddress(apiUrl, accessToken, customerId, request) {
  return unwrapResponse(
    await fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/addresses`, {
      method: "PUT",
      headers: {
        ...acceptJson,
        ...postJson,
        ...authHeader(accessToken)
      },
      body: JSON.stringify({
        ...request.fields,
        addressTypes: request.addressTypes,
        ...optionalKey("externalId", String(request.externalId ?? ""))
      })
    })
  );
}
export {
  changeAddress
};
//# sourceMappingURL=change-address.js.map
